<template>
<div>
    <Modal
        class-name="vertical-center-modal"
        label-position="left"
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'600px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80" >

                <FormItem :label="$t('BasicProduct.titleName.imageId')" prop="imageId" class="imgCon ivu-form-item-required" style="width: 500px;display: flex;align-items: center;">
                    <ImgUpload style="margin-top: 10px" ref="upLogoImg" :maxSize="2048" :types="['jpg','png','jpeg']" :action="uploadUsersAvatar" :hasUpload="hasUpload" :num="1"  @setThumbUrl="setThumbUrlthumb($event,'imageId')"  @removeThumbUrl="removeThumbUrl('imageId')"></ImgUpload>
                    <span class="simple-size">{{ $t('onboardingBanner.photoSTip') }}</span>
                </FormItem>
               
                
                <FormItem :label="$t('onboardingBanner.link')" prop="businessUrl" style="width: 500px">
                    <Input type="text" v-model.trim="formData.businessUrl" :placeholder="$t('ruleCustom.httpLink')"></Input>
                </FormItem>
                
                <FormItem  :label="$t('onboardingBanner.order')" prop="sortNum" style="width: 500px">
                    <InputNumber  :min="1" v-model="formData.sortNum" :placeholder="$t('inputPlaceholder')" :precision="0"></InputNumber>
                    <!-- <span class="simple-size">{{ $t('onboardingBanner.orderTip') }}</span> -->
                </FormItem>
         
                <FormItem :label="$t('productManage.addModel.remark')" prop="remark" style="width: 500px">
                    <Input  maxlength="100" show-word-limit type="textarea" v-model.trim="formData.remark" :placeholder="$t('inputPlaceholder')" ></Input>
                </FormItem>
       
        </Form>

        <div class="flexCC">
          <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
          <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
        </div>


      

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import ImgUpload from "@/views/common/upload";
import { mapState } from 'vuex'

// let uid = sessionStorage.getItem('uInfo')?JSON.parse(sessionStorage.getItem('uInfo')).id:''

    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        components: {
            ImgUpload,
        },
        data() {
            return {   
                pagesIdListUrl: this.config.urlArray.pagesIdList,//页面编号
                productsGroupListUrl: this.config.urlArray.productsGroupList,//产品分组
                uploadUsersAvatar:this.config.urlArray.uploadImg, //上传图片接口
                hasUpload: [], //已上传图片
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                templetBox:{//规格弹框组-移动
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    tempIdObj:{}
                },
                functionBox:{//规格弹框组-移动
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                },
                formData: {//表单数据
                    dealerId:'',//经销商编号
                    businessUrl: '',//外部链接
                    imageId:'',
                    remark:'', 
                    sortNum:1,//排序权重
                },
            }
        },
        watch:{
            showModel(val){
                if(val){
                    
                }
            }
        },
        computed:{
            ...mapState(['local','selectId','uInfo']),
            roleType(){
	        	let res = '3'
	        	if(this.uInfo && this.uInfo.roleType){
	        	 res = this.uInfo.roleType
	        	}
	        	return res
	        },
            selectObj(){
                return {
                   
                }
            },
            ruleCustom(){
                return {
                    businessUrl: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                        {pattern: /^(https?:\/\/)([^\s/$.?#][^\s]{2,})?([^\s]*)$/i, message: this.$t('ruleCustom.httpLink'), trigger:'blur'}
                    ],
                    sortNum: [
                        {required: true, type:'number', message: this.$t('required'),trigger: 'blur' },
                    ],
                    imageId: [
                      { required: true, message: this.$t('required'), trigger: 'change' }
                    ]
                }
            }

        },
        created(){
           
        },
        mounted(){
        },
        methods: {
          
            setThumbUrlthumb(item,name='imageId') {//图片上传
              this.formData[name]= item.data;
            },
            removeThumbUrl(name='imageId'){
                this.formData[name] = '';
            },
            openOrClose(value) {
                if(value === true) {
                    this.title = this.type == 1?this.$t('onboardingBanner.titleName'):this.$t('onboardingBanner.titleNameEdit')

                    if(this.type == 2){//编辑表单时，给表单赋值

                        for (let key in this.editFormData) {
                            if (this.formData.hasOwnProperty(key)) {
                                this.formData[key] = this.editFormData[key]
                            }
                        }
                        this.formData.sortNum = this.editFormData.sortNum*1 || 1

                        

                        this.$nextTick(()=>{//select赋值，图片赋值
                            let hasUpload1 = [{
                              status:'finished',
                              response:{data:this.formData.imageId}
                            }]
                            this.$refs.upLogoImg.setHasUpload(hasUpload1) 
                           
                        });
                    }
        
                } else { //关闭弹框后要做的处理
                 
                    this.resetForm();//重置表单
                    this.$refs.upLogoImg.clearImg()
                }
            },
            subData(name) {//提交表单
                
                this.$refs[name].validate((valid) => {
                    if (valid) {

                        let url = this.config.urlArray.createAdvertise
                        let params = { 
                            ...this.formData,
                            dealerId:this.selectId
                        }
                        if (this.type == 2) {
                            params.id = this.editFormData.id
                            url = this.config.urlArray.updateAdvertise
                        }
                        console.log(params)
                        this.disabled = true;
                        this.axios.post(url, params).then((result) => {
                            
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{
                                this.disabled = false;
                            })
                            
                            
                        }).catch((err) => {
                            this.disabled = false;
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.resetForm();//重置表单
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                this.formData.sortNum = 1
            }
        }
    }
</script>
<style lang='less' scoped>
/deep/ .ivu-modal-mask{
    z-index: 1016 !important;
}
/deep/ .ivu-modal-wrap{
    z-index: 1016 !important;
}
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}

.imgCon{
    /deep/ .ivu-form-item-content{
        margin-left: 0 !important;
    }
}


/deep/ .ivu-input-number{
    width: 100% !important;
}
.simple-size{
    margin-top: -20px;
}

</style>
